// extracted by mini-css-extract-plugin
module.exports = {"footer_top":"Footer_footer_top__DYGsf"};